/** Naver Maps JS zoom offset vs MapLibre (Naver map tab deep links). */

export const NAVER_MAP_ZOOM_MIN = 4;
export const NAVER_MAP_ZOOM_MAX = 20;

/**
 * Naver's map zoom matches MapLibre zoom minus one (tile level = param + 1; verified headless).
 */
export function maplibreZoomToNaverZoom(maplibreZoom: number): number {
  const z = Math.round(maplibreZoom - 1);
  return Math.min(NAVER_MAP_ZOOM_MAX, Math.max(NAVER_MAP_ZOOM_MIN, z));
}

/** Inverse of {@link maplibreZoomToNaverZoom} when copying the Naver view back to MapLibre. */
export function naverZoomToMaplibreZoom(naverZoom: number): number {
  return naverZoom + 1;
}
